const state = {
  clickslide: {}, // 获取首页底部 动效点击的具体图标 在地图标点用
  monitorList: [], // 首页请求的监控列表
}

const mutations = {
  SET_CLICKSLIDE: (state, obj) => {
    state.clickslide = obj
  },
  SET_MONITOR: (state, data) => {
    state.monitorList = data
  },
}
const getters = {
  clickslide: (state) => state.clickslide,
  monitorList: (state) => state.monitorList,
}
const actions = {
  setClickslide({ commit }, obj) {
    commit('SET_CLICKSLIDE', obj)
  },
  setMonitor({ commit }, data) {
    commit('SET_MONITOR', data)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
